import { Dispatch } from "redux";
import actions from "@state/actions";
import { IUserAccess } from "./types";

export const fetchUsersAccess = (dispatch: Dispatch, query: string) => {
  return new Promise<IUserAccess[]>((resolve, reject) => {
    dispatch(actions.userAccess.fetchUserAccess(query, (result, error) => {
      if (error) reject(error);
      else resolve(result);
    }))
  })
}

export const getUserAccessByEmail = (dispatch: Dispatch, email: string) => {
  return new Promise<IUserAccess | null>((resolve, reject) => {
    dispatch(actions.userAccess.getUserAccessByEmail(email, (result, error) => {
      if (error) reject(error);
      else resolve(result);
    }))
  })
}

export const postUserAccess = (dispatch: Dispatch, userAccess: IUserAccess) => {
  return new Promise<IUserAccess>((resolve, reject) => {
    dispatch(actions.userAccess.addUserAccess(userAccess, (result, error) => {
      if (error) reject(error);
      else resolve(result);
    }))
  })
}

export const putUserAccess = (dispatch: Dispatch, userAccess: IUserAccess) => {
  return new Promise<IUserAccess>((resolve, reject) => {
    dispatch(actions.userAccess.putUserAccess(userAccess, (result, error) => {
      if (error) reject(error);
      else resolve(result);
    }))
  })
}
